module.exports = __webpack_public_path__ + "static/media/ios-headset.9706bb00.svg";